var styles = {
  "bar": "pb-ProgressIndicator__bar",
  "indicator": "pb-ProgressIndicator__indicator",
  "labelWrapper": "pb-ProgressIndicator__labelWrapper",
  "stepLabel": "pb-ProgressIndicator__stepLabel",
  "stageTitle": "pb-ProgressIndicator__stageTitle",
  "stageTitleDivider": "pb-ProgressIndicator__stageTitleDivider",
  "progressWrapper": "pb-ProgressIndicator__progressWrapper",
  "counter": "pb-ProgressIndicator__counter",
  "counter__item": "pb-ProgressIndicator__counter__item",
  "counter__itemWrapper": "pb-ProgressIndicator__counter__itemWrapper",
  "counter__inner": "pb-ProgressIndicator__counter__inner",
  "counter__item--active": "pb-ProgressIndicator__counter__item--active",
  "counter__item--inactive": "pb-ProgressIndicator__counter__item--inactive",
  "counter__icon": "pb-ProgressIndicator__counter__icon"
};
export default styles;